/**
 * Features Carousel - Horizontal scrolling feature cards carousel
 */

(function() {
  'use strict';

  function initFeaturesCarousel(carouselWrapper) {
    const carouselId = carouselWrapper.dataset.carouselId;
    const track = carouselWrapper.querySelector(`.features-carousel-track[data-carousel-id="${carouselId}"]`);
    const prevBtn = carouselWrapper.querySelector(`.features-carousel-nav-prev[data-carousel-id="${carouselId}"]`);
    const nextBtn = carouselWrapper.querySelector(`.features-carousel-nav-next[data-carousel-id="${carouselId}"]`);
    const cards = track ? track.querySelectorAll('.features-carousel-card') : [];

    if (!track || !prevBtn || !nextBtn || cards.length === 0) return;

    let currentIndex = 0;
    const cardWidth = 320;
    const gap = 30;
    const cardsPerView = Math.floor((track.parentElement.offsetWidth) / (cardWidth + gap));
    const maxIndex = Math.max(0, cards.length - cardsPerView);

    function updateCarousel() {
      const offset = currentIndex * (cardWidth + gap);
      track.style.transform = `translateX(-${offset}px)`;

      // Update button states
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    function nextSlide() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    }

    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }

    nextBtn.addEventListener('click', nextSlide);
    prevBtn.addEventListener('click', prevSlide);

    // Initialize
    updateCarousel();

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newCardsPerView = Math.floor((track.parentElement.offsetWidth) / (cardWidth + gap));
        const newMaxIndex = Math.max(0, cards.length - newCardsPerView);
        if (currentIndex > newMaxIndex) {
          currentIndex = newMaxIndex;
        }
        updateCarousel();
      }, 250);
    });
  }

  // Initialize all features carousels
  function initAllFeaturesCarousels() {
    const carousels = document.querySelectorAll('.features-carousel-wrapper');
    carousels.forEach(carousel => {
      initFeaturesCarousel(carousel);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFeaturesCarousels);
  } else {
    initAllFeaturesCarousels();
  }

  // Re-initialize on Shopify section load
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.detail.querySelector('.features-carousel-wrapper');
      if (carousel) {
        initFeaturesCarousel(carousel);
      }
      initViewMoreButtons(event.detail);
    });
  }

  // View More functionality
  function initViewMoreButtons(container = document) {
    const viewMoreButtons = container.querySelectorAll('.features-carousel-view-more');
    
    viewMoreButtons.forEach(button => {
      // Check if text needs truncation
      const textWrapper = button.closest('.features-carousel-card-text-wrapper');
      const textElement = textWrapper?.querySelector('.features-carousel-card-text');
      
      if (!textElement || !textWrapper) return;
      
      // Temporarily remove line-clamp to measure full height
      const originalDisplay = textElement.style.display;
      const originalWebkitLineClamp = textElement.style.webkitLineClamp;
      textElement.style.display = 'block';
      textElement.style.webkitLineClamp = 'unset';
      
      // Measure the actual height
      const fullHeight = textElement.scrollHeight;
      
      // Restore line-clamp
      textElement.style.display = originalDisplay || '';
      textElement.style.webkitLineClamp = originalWebkitLineClamp || '4';
      
      // Calculate 4-line height
      const lineHeight = parseFloat(getComputedStyle(textElement).lineHeight);
      const maxHeight = lineHeight * 4;
      
      if (fullHeight <= maxHeight) {
        // Text fits in 4 lines, hide the button
        button.classList.remove('show');
        return;
      }
      
      // Show the button if text exceeds 4 lines
      button.classList.add('show');
      
      // Add click handler
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const viewMoreText = button.querySelector('.view-more-text');
        const isExpanded = textElement.classList.contains('expanded');
        
        if (isExpanded) {
          textElement.classList.remove('expanded');
          button.classList.remove('expanded');
          viewMoreText.textContent = 'View more';
        } else {
          textElement.classList.add('expanded');
          button.classList.add('expanded');
          viewMoreText.textContent = 'View less';
        }
      });
    });
  }

  // Initialize view more buttons
  function initAllViewMoreButtons() {
    initViewMoreButtons();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllViewMoreButtons);
  } else {
    initAllViewMoreButtons();
  }
})();
